<template>
    <div class="d-flex bg_auth">
        <v-row no-gutters dense class="d-flex">
            <v-col class="d-flex justify-center" :cols="$vuetify.display.mobile ? 12 : 3">
                <companyLogoView v-if="companyId" :companyId="companyId" cssStyle="height: 50px;" />
            </v-col>
            <v-col :cols="$vuetify.display.mobile ? 12 : 6">
                <v-tabs show-arrows align-tabs="center" center-active v-model="documentIterator">
                    <template v-for="document in displayDocuments" :key="document.documentId">
                        <v-tab>
                            {{ document.title }}
                        </v-tab>
                    </template>
                </v-tabs>
                <v-window v-model="documentIterator">
                    <v-window-item
                        class="mt-4"
                        v-for="document in documents"
                        :key="document.documentId"
                    >
                        <ossPdf
                            style="
                                max-height: 92vh;
                                max-width: 100vw;
                                overflow-y: auto;
                                overflow-x: hidden;
                            "
                            :signedUrl="document.signedUrl"
                        >
                        </ossPdf>
                    </v-window-item>
                </v-window>
            </v-col>
            <v-col
                :cols="$vuetify.display.mobile ? 12 : 3"
                class="d-flex flex-column justify-space-between"
            >
                <resumeView
                    :type="type"
                    :invoices="documents"
                    :data="data"
                    :documentSignedUrl="documentSignedUrl"
                    class="mr-4 ml-4 mt-16"
                >
                </resumeView>
                <div class="d-flex flex-row justify-end">
                    <v-img
                        src="@/assets/img/bobbee_hrz.png"
                        :max-height="30"
                        :max-width="149"
                        class="mr-4 mb-4"
                    />
                </div>
            </v-col>
        </v-row>
    </div>
</template>
<script lang="ts">
import ossPdf from "./PublicDocumentPDF.vue";
import companyLogoView from "./PublicCompanyLogoView.vue";
import resumeView from "./PublicInvoiceResume.vue";

import { Apollo } from "@/decorators";

import GET_MAIL_DOCUMENT_ID from "@/graphql/GetMailDocumentId.gql";
import GET_INVOICE_STATUS from "@/graphql/invoice/GetInvoiceStatus.gql";
import GET_DOCUMENT_DATA from "@/graphql/document/GetDocumentData.gql";
import GET_INVOICE_ID_FROM_DOCUMENT_ID from "@/graphql/GetInvoiceIdFromDocumentId.gql";

import getEnv from "../../../env";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

const env = getEnv();

@Component({
    components: {
        ossPdf,
        companyLogoView,
        resumeView,
    },
})
export class PublicInvoiceView extends Vue {
    @Prop() mailId: string;

    companyId: string = "";

    data: any = {};
    type: string = "facture";
    documentIterator = 0;
    documentSignedUrl: string = "";

    @Apollo({
        query: GET_MAIL_DOCUMENT_ID,
        variables() {
            return {
                id: this.mailId,
                isFromMail: this.$route?.query?.isFromMail === "false" ? false : true,
            };
        },
        skip() {
            return !this.mailId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading && data?.getMailDocumentId?.data?.payment?.accountingLines?.length) {
                this.documents = data.getMailDocumentId.data.payment.accountingLines.map(
                    (accountingLine) => {
                        return {
                            title: accountingLine.invoiceNumber,
                            documentId: accountingLine.documentId,
                            amountSigned: accountingLine.amountSigned,
                        };
                    },
                );
                this.documentId = this.documents[0].documentId;
                this.data = data.getMailDocumentId.data.payment;
            } else if (!loading && data?.getMailDocumentId?.data?.signature) {
                this.documents = [
                    {
                        documentId: data.getMailDocumentId.data.signature.documentId,
                        title: data.getMailDocumentId.data.signature.invoiceNumber,
                        amountSigned: data.getMailDocumentId.data.signature.amountSigned,
                    },
                ];
                this.data = data.getMailDocumentId.data.signature;
                this.isAlreadySigned();
                this.documentId = this.documents[0].documentId;
                this.type = "devis";
            }
            if (!loading && data?.getMailDocumentId?.companyId) {
                this.companyId = data.getMailDocumentId.companyId;
            }
        },
    })
    documents: any = [];

    get displayDocuments() {
        const documentIds: any = [];
        for (const document of this.documents) {
            let isUnique = true;
            for (const tmp of documentIds) {
                if (document.documentId === tmp.documentId) {
                    isUnique = false;
                    break;
                }
            }
            if (isUnique) {
                documentIds.push({ documentId: document.documentId, title: document.title });
            }
        }
        return documentIds;
    }

    @Watch("documents")
    async loadDocumentsSignedUrl() {
        for (const document of this.documents) {
            const result = await this.$apollo.query({
                query: GET_INVOICE_ID_FROM_DOCUMENT_ID,
                variables: {
                    id: document.documentId,
                },
            });
            if (result.data.getInvoiceIdFromDocumentId?.signedUrl) {
                document.signedUrl = result.data.getInvoiceIdFromDocumentId.signedUrl;
            }
        }
        this.documentSignedUrl = this.documents[0].signedUrl;
    }

    @Watch("documentIterator")
    updateDocumentId() {
        this.documentSignedUrl = this.documents[this.documentIterator].signedUrl;
    }

    async isAlreadySigned() {
        const result = await this.$apollo.query({
            query: GET_INVOICE_STATUS,
            variables: {
                invoiceId: this.data.invoiceId,
            },
        });
        console.log(result);
        if (result.data.publicInvoiceGetStatus.status === "SIGNED") {
            this.data.alreadySigned = true;
            return;
        } else if (result.data.publicInvoiceGetStatus.status === "BEING_SIGNED") {
            const documentResult = await this.$apollo.query({
                query: GET_DOCUMENT_DATA,
                variables: {
                    documentId: this.documents[0].documentId,
                },
            });
            if (documentResult.data.publicDocumentGetData.data) {
                const data = JSON.parse(
                    JSON.stringify(documentResult.data.publicDocumentGetData.data),
                );
                if (data.signature?.signUrl) {
                    this.data.signatureUrl = data.signature.signUrl;
                }
                if (data.signature?.transactionId) {
                    this.data.transactionId = data.signature.transactionId;
                }
            }
        }
    }
}

export default toNative(PublicInvoiceView);
</script>

<style scoped>
.bg_auth {
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: right;
    background-image: url("../../../assets/img/bg_auth.jpg");
    background-size: cover;
    background-repeat: no-repeat;
    background-position-x: center;
    overflow: unset;
}

.download_button {
    position: absolute;
    bottom: 16px;
    right: 47.5%;
}

::-webkit-scrollbar {
    width: 1px;
}
::-webkit-scrollbar-track {
    background: #f1f1f1;
}
::-webkit-scrollbar-thumb {
    background: #888;
}
</style>
